module.exports = __webpack_public_path__ + "static/media/undraw_percentages_0rur.b1977be3.svg";